import dynamic from 'next/dynamic';
import { SVGProps } from 'react';

export const LocationIcon = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./location.svg'),
);
export const EmailIcon = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./email.svg'),
);
export const PhoneIcon = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./phone.svg'),
);
export const MachineIcon = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./machine.svg'),
);
export const ArrowRightIcon = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./arrowRight.svg'),
);
export const RankIcon = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./rank.svg'),
);
export const PhoneIconPrimary = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./phonePrimary.svg'),
);
export const EmailIconPrimary = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./emailPrimary.svg'),
);
export const LocationIconPrimary = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./locationPrimary.svg'),
);
export const ZaloIcon = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./zalo.svg'),
);
export const ZaloIconPrimary = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./zaloPrimary.svg'),
);
export const FacebookIcon = dynamic<SVGProps<SVGSVGElement>>(
  () => import('./facebook.svg'),
);
